<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent" style="height:auto">
            <span class="back" @click="$router.go(-1)"><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span>
            <div class="wrap">
                <div class="content">
                    <div class="main-box">
                        <div class="form">
                            <el-form
                                :model="form"
                                :rules="applyrules"
                                ref="applyForm"
                                label-width="100px"
                                class="demo-ruleForm"
                            >
                                <div class="kuang">
                                    <h5 class="page-title">
                                        <span class="blue title-line"></span>
                                        企业信息
                                    </h5>
                                    <div class="license">
                                        <dl>
                                            <dt>
                                                <div class="license_area">
                                                    <input
                                                        type="file"
                                                        class="uploadfile"
                                                        ref="inputer"
                                                        @change="chooseFile"
                                                    />
                                                    <img v-if="usccUrl" :src="usccUrl" alt="" />
                                                    <img
                                                        v-else
                                                        src="@/assets/images/realName/license.png"
                                                        alt=""
                                                    />
                                                    <p v-if="usccUrl">
                                                        重新上传
                                                    </p>
                                                </div>
                                            </dt>
                                            <dd>
                                                <div class="license_title">
                                                    认证资料（*请上传彩色原件或加盖公章的复印件）
                                                </div>
                                                <div class="des">
                                                    <p>
                                                        *格式要求：原件照片、扫描件、支持.jpg、.jpeg、.png、<br />.bmp格式照片，大小不超过10M
                                                    </p>
                                                </div>
                                            </dd>
                                        </dl>
                                    </div>

                                    <el-form-item
                                        label="企业名称"
                                        label-width="140px"
                                        prop="name"
                                    >
                                        <el-input
                                            disabled
                                            v-model="name"
                                            placeholder="请输入单位证件登记的名称"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="统一社会信用代码"
                                        label-width="140px"
                                        prop="uscc"
                                    >
                                        <el-input
                                            disabled
                                            v-model="uscc"
                                            placeholder="请输入统一的社会信用代码或组织机构代码"
                                        ></el-input>
                                    </el-form-item>
                                </div>

                                <div class="kuang">
                                    <h5 class="page-title">
                                        <span class="blue title-line"></span>
                                        银行开户信息
                                    </h5>
                                    <el-form-item
                                        label="企业开户名称"
                                        label-width="140px"
                                        prop="bankAccountName"
                                    >
                                        <el-input
                                            disabled
                                            v-model="form.bankAccountName"
                                            placeholder="请输入企业开户名称"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="企业开户银行"
                                        label-width="140px"
                                        prop="bankName"
                                    >
                                        <el-input
                                            v-model="form.bankName"
                                            placeholder="请输入企业开户银行"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="企业开户账号"
                                        label-width="140px"
                                        prop="bankNo"
                                    >
                                        <el-input
                                            v-model="form.bankNo"
                                            placeholder="请输入企业开户银行"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="开户支行名称"
                                        label-width="140px"
                                        prop="bankSubbranch"
                                    >
                                        <el-input
                                            v-model="form.bankSubbranch"
                                            placeholder="请输入开户支行名称"
                                        ></el-input>
                                    </el-form-item>
                                </div>

                                <div class="kuang">
                                    <h5 class="page-title">
                                        <span class="blue title-line"></span>
                                        联系人信息
                                    </h5>
                                    <el-form-item
                                        label="联系人姓名"
                                        label-width="140px"
                                        prop="contactsName"
                                    >
                                        <el-input
                                            v-model="form.contactsName"
                                            placeholder="请输入联系人姓名"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label="联系人手机号"
                                        label-width="140px"
                                        prop="contactsPhone"
                                    >
                                        <el-input
                                            v-model="form.contactsPhone"
                                            placeholder="请输入联系人手机号"
                                        ></el-input>
                                    </el-form-item>
                                    
                                    <div class="yzm-item">
                                        <el-form-item
                                            label="验证码:"
                                            label-width="140px"
                                            prop="code"
                                        >
                                            <el-input
                                                v-model="form.code"
                                                placeholder="短信验证码"
                                            ></el-input>
                                        </el-form-item>
                                        <span
                                            :disabled="disabled"
                                            @click="getVerificationCode"
                                            >{{ yzmtext }}</span
                                        >
                                    </div>
                                    <!-- <div class="uploads">
                                        <div class="upload_title">
                                            企业服务授权书
                                        </div>
                                        <div class="format">
                                            文件格式要求'.pdf','.docx','.doc',''.jpg','.jpeg','.png','.bmp'，不超过10M；
                                        </div>
                                        <div class="upload">
                                            <div class="up_area">
                                                <input type="file" class="uploadfile" ref="inputer" @change="chooseFile" />
                                                <img style="width:auto;height:auto;max-width:100%;max-height:100%" v-if="viewUrl" :src="viewUrl" alt="">
                                                <img v-else src="@/assets/images/realName/upbg.png" alt="">
                                            </div>
                                        </div>
                                        <p class="warning">
                                            <i class="el-icon-warning"></i
                                            >&nbsp;&nbsp;&nbsp;&nbsp;企业服务授权书，必须盖有公司印章，
                                            <a href="https://tsa-public-test.oss-cn-beijing.aliyuncs.com/account/%E4%BC%81%E4%B8%9A%E5%AE%9E%E5%90%8D%E6%8E%88%E6%9D%83%E4%B9%A6%E6%A8%A1%E6%9D%BF.pdf" target="_blank" download="联合信任企业实名授权书模板">下载授权书</a>
                                        </p>
                                    </div> -->
                                    <el-form-item
                                        label="联系人身份证号码"
                                        label-width="140px"
                                        prop="contactsIdCard"
                                    >
                                        <el-input
                                            v-model="form.contactsIdCard"
                                            placeholder="请输入联系人身份证号码"
                                            style="ime-mode:disabled"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item
                                        label-width="140px"
                                    >
                                        <span slot="label"><b style="color:#F56C6C;margin-right: 4px;">*</b>联系人身份证照片</span>
                                        <div class="idCard">
                                            <div class="box">
                                                <div class="up_area">
                                                    <input type="file" class="uploadfile" ref="idcard_front" @change="chooseIdCard(0)" />
                                                    <img style="width:auto;height:auto;max-width:100%;max-height:100%" v-if="idcard_front_viewUrl" :src="idcard_front_viewUrl" alt="">
                                                    <img v-else src="@/assets/images/realName/idcard_front.png" alt="">
                                                </div>
                                                <div class="des">
                                                    <b>点击上传身份证人像面</b>
                                                    <p>（支持格式为png、jpg、jpeg，文件大小不超过10MB）</p>
                                                </div>
                                            </div>
                                            <div class="box">
                                                <div class="up_area">
                                                    <input type="file" class="uploadfile" ref="idcard_tails" @change="chooseIdCard(1)" />
                                                    <img style="width:auto;height:auto;max-width:100%;max-height:100%" v-if="idcard_tails_viewUrl" :src="idcard_tails_viewUrl" alt="">
                                                    <img v-else src="@/assets/images/realName/idcard_tails.png" alt="">
                                                </div>
                                                <div class="des">
                                                    <b>点击上传身份证国徽面</b>
                                                    <p>（支持格式为png、jpg、jpeg，文件大小不超过10MB）</p>
                                                </div>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </div>

                                <div class="submit">
                                    <span @click="onSubmit('applyForm')">提交</span>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="zhe" v-if="progress">
                <div class="progress">
                    <el-progress type="circle" :percentage="percentage"></el-progress>
                </div>
            </div>
        </div>
        <div id="captcha-element"></div>
    </el-row>
</template>

<script>
import {sendMsg,entRemittanceApply,authUploadInfo,getIdCardUploadUrl,entRemittanceFeedback,businessUploadInfo } from '@http/user_center/realName'
import { identification } from "@http/user_center/userInfo";
import NoTrace from '@/utils/noTrace';
var interval = null;
export default {
    data() {
        var vuscc = (rule, value, callback) => {
            if (!/^[A-Za-z0-9-]{6,40}$/.test(value)) {
                callback(new Error("统一社会信用代码格式不正确"));
            }
            callback();
        };
        var vphone = (rule, value, callback) => {
            if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        var space=(rule, value, callback) => {
            if (value.toString().replace(/\s/g,"")=='') {
                callback(new Error("输入内容不能全为空格"));
            }
            callback();
        };
        var checkFont=(rule, value, callback)=> {
            if (value) {
                if (/[\u4E00-\u9FA5]/g.test(value)) {
                    callback(new Error('不能输入中文字符'));
                } else {
                    callback();
                }
            }
            callback();
        }
        return {
            idcard_front_viewUrl:'',
            idcard_tails_viewUrl:'',
            name: "",
            uscc: "",
            form:{
                bankAccountName:"",
                bankName:"",
                bankNo:"",
                bankSubbranch:"",
                contactsName:"",
                contactsPhone:"",
                contactsIdCard:'',
                code:"",
                //authorizationUrl:'',
                sourceType:975260,
                contactsFrontIdCardPath:'',
                contactsBackIdCardPath:'',
            },
            fil:{},
            applyrules: {
                bankAccountName: [
                    {
                        required: true,
                        message: "请输入企业开户名称",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                ],
                bankName: [
                    {
                        required: true,
                        message: "请输入企业开户银行",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                ],
                bankNo: [
                    {
                        required: true,
                        message: "请输入企业开户账号",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                ],
                bankSubbranch: [
                    {
                        required: true,
                        message: "请输入开户支行名称",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                ],
                contactsName: [
                    {
                        required: true,
                        message: "请输入联系人姓名",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                ],
                contactsPhone: [
                    {
                        required: true,
                        message: "请输入联系人手机号",
                        trigger: "blur",
                    },
                    { validator: vphone, trigger: "blur" },
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                    { validator: checkFont, trigger: "blur" },
                ],
                contactsIdCard:[
                    {
                        required: true,
                        message: "请输入联系人身份证号码",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                    { validator: checkFont, trigger: "blur" },
                ]
            },
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 60,
            nvc:'',
            //downFileUrl:'',
            percentage:0,
            currentRate:0,
            progress:false,
            remittanceInfo:{},
            fil: {},
            usccUrl: "",
            percentage: 0,
        };
    },
    components: {
    },

    computed: {},

    async created() {
        identification().then((res) => {
            let {authenticationStatus} = res;
            if(authenticationStatus==6){
                this.$router.replace({
                    path:'/userCenter/realName/enterpriseResult'
                })
            }else if(authenticationStatus==4 || authenticationStatus==8){
                this.form.contactsName=res.enterprise.contactsName;
                this.form.bankAccountName=res.enterprise.bankAccountName;
                this.form.contactsPhone=res.enterprise.contactsPhone;
            }else{
                this.$router.replace({
                    path:'/userCenter/AuconsolethenticationName'
                })
            }
        }).catch((err) => {
            console.log(err);
        });

        //回显数据
        entRemittanceFeedback().then((res) => {
            this.name = res.name;
            this.uscc = res.uscc;
            this.usccUrl = res.businessAccessUrl;
            this.idcard_front_viewUrl=res.contactsFrontIdCardAccessUrl || '';
            this.idcard_tails_viewUrl=res.contactsBackIdCardAccessUrl || '';
            this.form.businessUrl = res.businessUrl || '';
            this.form.bankAccountName = res.bankAccountName || this.form.bankAccountName || '';
            this.form.bankName = res.bankName || '';
            this.form.bankNo = res.bankNo || '';
            this.form.bankSubbranch = res.bankSubbranch || '';
            this.form.contactsName = res.contactsName || '';
            this.form.contactsPhone = res.contactsPhone || '';
            this.form.contactsIdCard = res.contactsIdCard || '';
            this.form.contactsFrontIdCardPath=res.contactsFrontIdCardPath || '';
            this.form.contactsBackIdCardPath=res.contactsBackIdCardPath || '';
            console.log(res);
        }).catch((err) => {
            console.log(err);
        });
    },


    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },

    methods: {
        chooseFile() {
            let that = this;
            let inputDOM = this.$refs.inputer;
            this.fil = inputDOM.files;
            let size = Math.floor(this.fil[0].size);
            let name = inputDOM.files[0].name;
            let index = name.lastIndexOf(".");
            let Format = name.substring(index);
            let arry_format = [".jpg", ".jpeg", ".png", ".bmp"];
            if (arry_format.indexOf(Format) == "-1") {
                this.$msg("文件格式不符合要求");
                this.fil = {};
                this.$refs.inputer.value = null;
                return false;
            }
            if (size > 10 * 1024 * 1000) {
                this.$msg("文件大小不能大于10M");
                this.fil = {};
                this.$refs.inputer.value = null;
                return false;
            }
            businessUploadInfo()
                .then((res) => {
                    this.$request({
                        method: "PUT",
                        url: res.uploadUrl,
                        data: that.fil[0].slice(0, that.fil[0].size),
                        timeout: 86400000,
                        headers: {
                            "content-type": "application/octet-stream",
                        },
                        onUploadProgress: function(progressEvent) {
                            that.progress = true;
                            that.percentage =
                                Math.floor(
                                    (progressEvent.loaded /
                                        progressEvent.total) *
                                        100
                                ) | 0;
                        },
                    })
                        .then(async () => {
                            that.usccUrl = res.viewUrl;
                            that.form.businessUrl = res.businessUrl;
                            that.progress = false;
                            that.form.sourceType =
                                    that.$getlocalStorage("queryData")
                                        ?.sourceType ||
                                    that.$getlocalStorage("queryData")
                                        ?.clientId ||
                                    975260;
                            setTimeout(() => {
                                that.percentage = 0;
                                that.currentRate = 0;
                            }, 2000);
                        })
                        .catch((err) => {
                            console.log(err);
                            that.$refs.inputer.value=null;
                            that.usccUrl = '';
                            that.form.businessUrl='';
                            that.progress = false;
                            setTimeout(() => {
                                that.percentage = 0;
                                that.currentRate = 0;
                            }, 2000);
                        });
                })
        },
        async getVerificationCode() {
            var that = this;
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35022,
                    "logParam":{
                        'phone':that.form.contactsPhone
                    }
                },
            });
            let { contactsPhone } = that.form;
            if (!contactsPhone) {
                that.$msg("联系人手机号不能为空");
                return false;
            }
            let reg = /^1[3456789]\d{9}$/;
            if (!reg.test(contactsPhone)) {
                that.$msg("手机号格式不正确");
                return false;
            }
            this.getCode();
            that.disabled = true;

            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                phone: that.form.contactsPhone,
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg(res.message, "success");
                }catch (err) {
                    reject(err)
                    that.$msg('发送失败')
                    clearInterval(interval);
                    that.yzmtext = "获取验证码";
                    that.disabled = false;
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = 60;
                    that.disabled = false;
                }
            }, 1000);
        },
        // chooseFile(){
        //     let that=this;
        //     let inputDOM = this.$refs.inputer;
        //     this.fil = inputDOM.files; 
        //     let size = Math.floor(this.fil[0].size);
        //     let name = inputDOM.files[0].name;
        //     let index = name.lastIndexOf('.');
        //     let Format=name.substring(index)
        //     let arry_format=['.pdf','.doc','.docx','.jpg','.jpeg','.png','.bmp']
        //     if(arry_format.indexOf(Format)=='-1'){
        //         this.$msg("文件格式不符合要求");
        //         this.fil={};
        //         this.$refs.inputer.value=null;
        //         return false;
        //     }
        //     if(size > 10 * 1024 * 1000){
        //         this.$msg("文件大小不能大于10M");
        //         this.fil={};
        //         this.$refs.inputer.value=null;
        //         return false;
        //     }
        //     authUploadInfo({extension:name.substring(index+1)}).then((res)=>{
        //         this.$request({
        //             method: "PUT",
        //             url: res.uploadUrl,
        //             data:that.fil[0].slice(0, that.fil[0].size),
        //             timeout:86400000,
        //             headers: {
        //                 'content-type':'application/octet-stream'
        //             },
        //             onUploadProgress:function(progressEvent){
        //                 that.progress = true;
        //                 that.percentage =((progressEvent.loaded / progressEvent.total) * 100) | 0
        //             }
        //         }).then(async () => {
        //             if(['.jpg','.jpeg','.png','.bmp'].includes(Format)){
        //                 that.viewUrl=res.viewUrl;
        //             }else{
        //                  that.viewUrl=require("@/assets/images/fileicon.png");
        //             }
                    
        //             that.form.authorizationUrl=res.storageUrl;
        //             that.form.sourceType=that.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260
        //             that.progress = false;
        //             setTimeout(()=>{
        //                 that.percentage=0;
        //                 that.currentRate=0;
        //             },2000)
        //         }).catch((err) => {
        //             console.log(err);
        //         });
        //     }).catch((err)=>{
        //         this.$msg(err.message);
        //     })
        // },
        
        chooseIdCard(n){
            let that=this;
            let inputDOM;
            if(n==0){
                inputDOM = this.$refs.idcard_front;
            }else{
                inputDOM = this.$refs.idcard_tails;
            }
            let size = Math.floor(inputDOM.files[0].size);
            let name = inputDOM.files[0].name;
            let index = name.lastIndexOf('.');
            let Format=name.substring(index);
            let arry_format=['.jpg','.jpeg','.png'];
            if(arry_format.indexOf(Format)=='-1'){
                this.$msg("文件格式不符合要求");
                n==0?this.$refs.idcard_front.value=null : this.$refs.idcard_tails.value=null;
                return false;
            }
            if(size > 10 * 1024 * 1000){
                this.$msg("文件大小不能大于10M");
                n==0?this.$refs.idcard_front.value=null : this.$refs.idcard_tails.value=null;
                return false;
            }
            getIdCardUploadUrl().then((res)=>{
                that.percentage=0;
                that.currentRate=0;
                this.$request({
                    method: "PUT",
                    url: res.uploadUrl,
                    data:inputDOM.files[0].slice(0, inputDOM.files[0].size),
                    timeout:86400000,
                    headers: {
                        'content-type':'application/octet-stream'
                    },
                    onUploadProgress:function(progressEvent){
                        that.progress = true;
                        that.percentage =((progressEvent.loaded / progressEvent.total) * 100) | 0
                    }
                }).then(async () => {
                    n==0 ? that.idcard_front_viewUrl=res.viewUrl : that.idcard_tails_viewUrl=res.viewUrl;
                    n==0 ? that.form.contactsFrontIdCardPath=res.storeUrl : that.form.contactsBackIdCardPath=res.storeUrl;
                    that.progress = false;
                    setTimeout(()=>{
                        that.percentage=0;
                        that.currentRate=0;
                    },2000)
                }).catch((err) => {
                    console.log(err);
                    that.progress = false;
                    n==0 ? that.idcard_front_viewUrl='' : that.idcard_tails_viewUrl='';
                    n==0 ? that.form.contactsFrontIdCardPath='' : that.form.contactsBackIdCardPath='';
                    setTimeout(()=>{
                        that.percentage=0;
                        that.currentRate=0;
                    },2000)
                });
            }).catch((err) => {
                console.log(err);
            });


        },
        onSubmit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if(!this.form.contactsFrontIdCardPath){
                        this.$msg("请上传身份证人像面照片");
                        return false;
                    }
                    if(!this.form.contactsBackIdCardPath){
                        this.$msg("请上传身份证国徽面照片");
                        return false;
                    }
                    this.$TsaWebTrace.post({
                        data: {
                            "eventId": 35033,
                        },
                    });
                    entRemittanceApply(this.form).then(async ()=>{
                        this.$router.replace({
                            path:'/userCenter/realName/enterpriseResult'
                        })
                    })
                }
            })
        },
    },
};
</script>
<style src="@/assets/css/content.css" scoped></style>

<style scoped lang="less">
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.main-box {
    width: 940px;
    margin: 0 auto;
    .kuang {
        box-sizing: border-box;
        margin-bottom: 20px;
        padding: 32px;
        border: 1px solid #e8e8e8;
        box-shadow: 0px 4px 6px 0px rgba(172, 172, 172, 0.18);
        .page-title {
            margin-bottom: 30px;
            display: flex;
            align-items: center;
        }
    }
    .form {
        .el-form-item {
            width: 600px;
        }
        .yzm-item {
            width: 600px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .el-form-item {
                width: 400px;
            }
            span {
                width: 148px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                background: #fff;
                color: #3f7df7;
                cursor: pointer;
                border: 1px solid #3f7df7;
                font-size: 14px;
                margin-top: 3px;
                border-radius: 3px;
                &:hover {
                    background: #3f7df7;
                    color: #fff;
                }
            }
            span[disabled] {
                color: #fff;
                background: #bcbcbc;
                pointer-events: none;
                cursor: inherit;
                border-color: #bcbcbc;
            }
        }
        .idCard{
            width: 130%;
            display: flex;
            justify-content: space-between;
            .box{
                .up_area{
                    cursor:pointer;
                    width: 284px;
                    height: 164px;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .uploadfile{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        opacity: 0;
                        cursor:pointer;
                    }
                    img{
                        width: 284px;
                        height: 164px;
                    }
                }
                .des{
                    text-align: center;
                    line-height: 20px;
                    b{
                        display: block;
                        color: #3F7DF7;
                        font-size: 14px;
                        margin: 6px 0;
                    }
                    p{
                        color: #9C9C9C;
                        font-size: 12px;
                    }
                }
            }
        }
        .submit {
            margin-top: 32px;
            text-align: left;
            span{
                display: inline-block;
                width: 130px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                font-size: 16px;
                border-radius: 5px;
                border:1px solid #10A0E9;
                cursor: pointer;
                background:#10A0E9;
                color: #fff;
                margin-bottom: 20px;
                opacity: .7;
                &:hover{
                    opacity: 1;
                }
            }
        }
    }
}
.license {
    width: 675px;
    padding-left: 139px;
    margin-bottom: 30px;
    dl {
        width: 100%;
        display: flex;
        dt {
            margin-right: 21px;
            .license_area {
                position: relative;
                width: 274px;
                img {
                    width: 274px;
                    height: 168px;
                    border-radius: 15px;
                }
                .uploadfile {
                    cursor: pointer;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
                P{
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0,0.5);
                    display: none;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 20px;
                    z-index: 1;
                }
                &:hover {
                    p{
                        display: flex;
                    }
                }
            }
            h6 {
                font-size: 14px;
                margin-top: 20px;
                text-align: center;
                font-weight: 500;
            }
        }
        dd {
            text-align: center;
            .license_title {
                font-size: 16px;
                padding: 13px 0 19px;
            }
            .des {
                line-height: 30px;
                font-size: 14px;
                color: #c1c1c1;
            }
        }
    }
}
.uploads {
    padding-top: 10px;
    text-align: left;
    .upload_title {
        color: #333;
        font-size: 16px;
        margin-bottom: 10px;
    }
    .format {
        color: #999;
        font-size: 14px;
    }
    .warning {
        font-size: 14px;
        margin-top: 14px;
        a{
            color: #3080fe;
            text-decoration: underline;
        }
    }
    .upload{
        padding-top: 20px;
        .up_area{
            cursor:pointer;
            width: 243px;
            height: 163px;
            border: 1px dashed #ccc;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            .uploadfile{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                opacity: 0;
                cursor:pointer;
            }
            img{
                width: 243px;
                height: 163px;
            }
        }
        .download{
            color: #F15B64;
            font-size: 24px;
            margin-top: 30px;
            a{
                color: #5CA3FF;
                text-decoration: underline;
            }
        }
    }
}
.zhe {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    .progress {
        position: fixed;
        width: 126px;
        height: 126px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 99999;
        color: #fff;
        /deep/.el-progress__text{
            color:#fff
        }
    }
}

</style>

